/**
 * 获取 android 系统版本号
 * @param {*} ua navigator.userAgent
 */
type VersionType =
  | {
      SYS?: "android" | "ios";
      VCAll?: string;
      VC?: number;
    }
  | undefined;

export default function getAndroidVersion(UA: string): VersionType {
  if (!UA) return undefined;
  const ua = UA.toLowerCase();
  let version: VersionType = {};
  if (ua.indexOf("android") > 0) {
    version.SYS = "android";
    const reg = /android [\d._]+/gi;
    const vInfo = ua.match(reg);
    version.VCAll = (vInfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, "."); //得到版本号4.2.2
    version.VC = parseInt(version.VCAll.split(".")[0]); // 得到版本号第一位
  } else if (ua.indexOf("like mac os x") > 0) {
    version.SYS = "ios";
    const reg = /os [\d._]+/gi;
    const vInfo = ua.match(reg);
    version.VCAll = (vInfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, "."); //得到版本号9.3.2或者9.0
    version.VC = parseInt(version.VCAll.split(".")[0]); // 得到版本号第一位
  } else {
    version = undefined;
    // eslint-disable-next-line
    console.warn("can not get version, it is not android or ios");
  }

  return version;
}
